// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u32().primaryKey(),
  databaseName: __t.string().name("database_name"),
  moduleTypeName: __t.string().name("module_type_name"),
  deployedHash: __t.string().name("deployed_hash"),
  deployedVersion: __t.u64().name("deployed_version"),
  latestHash: __t.string().name("latest_hash"),
  latestVersion: __t.u64().name("latest_version"),
  updateAvailable: __t.bool().name("update_available"),
  deployedAt: __t.timestamp().name("deployed_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
